<div class="client-dropdown-field-row">
  <label class="client-dropdown-field-label" for="dropdown">{{ label }}</label>

  <div
    class="client-dropdown-dropdown"
    [class.open]="open"
    [class.dirty]="isDirty"
    (click)="$event.stopPropagation()"
  >
    <button
      class="client-dropdown-trigger"
      type="button"
      [attr.aria-haspopup]="true"
      [attr.aria-expanded]="open"
      (click)="toggle()"
    >
      {{ sponsorSelected || 'All' }}
      <span class="client-dropdown-chevron">
        <mat-icon svgIcon="caret-down" class="client-dropdown-caret"></mat-icon>
      </span>
    </button>

    <div class="client-dropdown-panel" *ngIf="open" role="listbox" tabindex="-1">
      <div class="client-dropdown-options">
        <div
          class="client-dropdown-option"
          role="option"
          [attr.aria-selected]="(pendingValue ?? sponsorSelected) === 'All'"
          [class.selected]="(pendingValue ?? sponsorSelected) === 'All'"
          (click)="select('All')"
        >
          All
        </div>

        <div
          class="client-dropdown-option"
          role="option"
          *ngFor="let sponsor of sponsors"
          [attr.aria-selected]="(pendingValue ?? sponsorSelected) === sponsor"
          [class.selected]="(pendingValue ?? sponsorSelected) === sponsor"
          (click)="select(sponsor)"
        >
          {{ sponsor }}
        </div>
      </div>

      <div class="client-dropdown-footer">
        <button
          class="client-dropdown-apply-btn"
          type="button"
          [disabled]="!isDirty"
          (click)="apply()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
